module.exports = __webpack_public_path__ + "static/media/close-k-10.1fee7c4b.png";